import React from 'react';

import { StyleSheet, Text, View } from 'react-native';

import { useDistanceText } from 'hooks/geolocation/use-distance-text';
import { useGeolocation } from 'state/geolocation';
import { primitive } from 'styles/constants/primitives';

import { DialogBodyProps } from '../types';

import { sharedStyles } from './shared.styles';

export const AvailableRestaurantDialogBody: React.FC<DialogBodyProps> = ({
  body,
  availableRestaurant,
  formatMessage,
}) => {
  const { isPermissionGranted } = useGeolocation();

  const { distanceText } = useDistanceText({
    restaurant: availableRestaurant,
    shouldUseUserCoordinatesIfAvailable: true,
  });

  return (
    <View style={styles.bodyContainer}>
      <Text style={sharedStyles.bodyText}>
        {body || formatMessage({ id: 'restaurantClosedDialogBody' })}
      </Text>
      <Text style={styles.restaurantText}>
        {availableRestaurant?.physicalAddress?.address1}
        {isPermissionGranted && <Text style={styles.distanceText}>{` - ${distanceText}`}</Text>}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  bodyContainer: {
    marginVertical: 12,
  },
  restaurantText: {
    fontSize: primitive.fontSizes.sm,
    fontFamily: primitive.fontFamily.$body,
    textAlign: 'center',
    paddingVertical: 32,
  },
  distanceText: {
    fontFamily: primitive.fontFamily.$headers,
  },
});
